// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/search-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/img/arrow-down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/img/pin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/img/pin-hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/img/arrow-right.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/eurostile-extended);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-first: #583760;
  --color-second: #b7d48c;
  --color-third: #ed7a58;
  --color-white: #f6efe3;
  --color-black: #161711;
  --color-first-opacity: #a793a1;
  --font-family-first: "Montserrat", sans-serif;
  --font-family-second: "Ubuntu", sans-serif;
}

.font-first {
  font-family: var(--font-family-first);
}
.font-second {
  font-family: var(--font-family-second);
}
html {
  width: 100%;
}

body {
  width: 100%;
  margin: 0;
  padding-top: 0;
  background: var(--color-white) !important;
  overflow: hidden;
}

a,
a img {
  text-decoration: none;
  outline: none;
  border: none;
}

a:hover {
  text-decoration: none !important;
}

.clr {
  clear: both;
  height: 0;
}

.fancybox-button svg path {
  color: #fff !important;
}

*,
*:after,
*::before {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style-type: none;
  outline: none;
}

a:focus {
  outline: 0;
}

a {
  text-decoration: none !important;
}

.left-menu-area {
  width: 25%;
  display: flex;
  flex-direction: column;
  padding: 40px;
  position: relative;
  background: var(--color-white);
  padding-bottom: 400px;
  height: 100vh;
  font-family: var(--font-family-first);
}

.content-wrapper {
  display: flex;
}
.search-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
}
.search-item input {
  border-radius: 5px;
  background: var(--color-first-opacity) url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat 6% 50%;
  background-size: 20px;
  border: 0;
  padding: 5% 15%;
  color: var(--color-white);
  width: 100%;
  font-size: 1cqw;
}
.search-item input::placeholder {
  color: var(--color-white);
}
.search-item img {
  width: 3cqw;
  margin-left: 5%;
  cursor: pointer;
}
.title-list {
  display: flex;
  align-items: center;
  color: var(--color-first);
  font-weight: 600;
  position: relative;
  font-size: 1.25cqw;
  margin-bottom: 1%;
  cursor: pointer;
}
.title-list::before {
  display: inline-flex;
  width: 2cqw;
  height: 1.5cqw;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  content: "";
  background-size: 1cqw;
  background-position: center;
  cursor: pointer;
}

.title-list-hide {
  display: flex;
  align-items: center;
  color: var(--color-first);
  font-weight: 600;
  position: relative;
  font-size: 1.25cqw;
  margin-bottom: 1%;
  cursor: pointer;
}
.title-list-hide::before {
  display: inline-flex;
  width: 1cqw;
  height: 1cqw;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  content: "";
  background-size: 1cqw;
  transform: rotate(-90deg);
  cursor: pointer;
}

.staking-list {
  display: flex;
  flex-direction: column;
  padding-left: 25px;
  margin-bottom: 20px;
}
.staking-list a {
  position: relative;
  display: flex;
  align-items: center;
  color: var(--color-black);
  font-size: 1cqw;
  font-weight: 400;
}
.staking-list a:before {
  display: inline-flex;
  width: 2cqw;
  height: 2cqw;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-position: center;
  background-size: 1cqw;
}
.staking-list a:hover::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-position: center;
  background-size: 1cqw;
}
.staking-list a:hover {
  color: #ee4c34;
}
.arr-right-link {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  width: 3cqw;
  height: 5cqw;
  background-size: 100%;
  position: absolute;
  right: -10%;
  top: 40%;
  transform: translate(-50%, 0);
  z-index: 2;
  cursor: pointer;
}

.right-map-area {
  width: 100%;
  position: absolute;
}
#map {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: calc(100vh - 100px);
}
.hider {
  background: var(--color-white);
  width: 100%;
  height: 108px;
  position: absolute;
  margin-top: -108px;
}
.tophider {
  background: var(--color-white);
  width: 100%;
  height: 108px;
  position: absolute;
  margin-top: -108px;
}
.pointer {
  cursor: pointer;
}
.pop {
  display: none;
  position: fixed;
  z-index: 99999;
  top: 0;
}
.pop img {
  width: 100%;
}
.title-list {
  cursor: pointer;
}
.shows {
  display: block;
}
.hides {
  display: none;
}
.wide {
  width: 100%;
}
.narrow {
  width: 80%;
}
.showsarrow {
  display: block;
  left: -1%;
  top: 50%;
  transform: rotate(180deg);
}
.hidesarrow {
  display: none;
}
.span2 {
  text-indent: 7px;
}
#loadingOverlay {
  /* margin-top: -24px; */
}
.globe {
  cursor: pointer;
  position: absolute;
  width: 41px;
  z-index: 99;
  left: 26%;
  background: var(--color-white);
  border-radius: 14px;
  padding: 5px;
  margin-top: 12px;
}
.search-list {
  position: absolute;
  z-index: 999;
  width: 100%;
  top: 12%;
  left: 0;
  padding: 0 10%;
}
.search-list .in {
  background-color: #fac3aeee;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}
.search-list a {
  color: var(--color-first);
  padding: 3%;
  cursor: pointer;
  font-size: 1cqw;
}
.search-list a:not(:last-child) {
  border-bottom: 1px solid var(--color-black);
}
.visible {
}
.hidden {
  display: none;
}
.cmap {
  position: absolute;
}
.w80 {
  width: 80%;
  height: 100%;
}
.loader {
  position: fixed;
  width: 100%;
  background: #f6efe3bd;
  z-index: 9999;
  height: 100%;
  top: 0;
  text-align: center;
}
.prtitle {
  width: 80cqw;
  height: 80cqh;
  border: 5px solid transparent;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 1.5cqw;
  padding: 2% 5%;
  font-weight: 600;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(var(--color-white) 0 0) padding-box,
    linear-gradient(
        to top,
        var(--color-first) 0%,
        var(--color-third) 50%,
        var(--color-second) 100%
      )
      border-box;
  overflow-y: auto;
  font-family: var(--font-family-first);
}

.prtitle::-webkit-scrollbar-track {
  background: none;
}

.prtitle::-webkit-scrollbar-thumb {
  background-color: var(--color-second);
  border-radius: 50px;
}
.prize-title {
  font-size: 1.5cqw;
  font-weight: 600;
}
.prtitle .prize-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30%;
  font-size: 1cqw;
  font-weight: 700;
}
.prtitle .prize-bottom-info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10%;
  font-size: 1cqw;
  font-weight: 700;
}
.prtitle .prize-card-area {
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 5%;
  position: relative;
  height: 38cqh;
}
.prtitle .prize-card-area .card-in {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}
.prtitle .prize-card-area .pady14 {
  padding: 2% 14%;
}
.prtitle .prize-card-area .pady10 {
  padding: 2% 10%;
}
.prtitle .prize-card-area .pady8 {
  padding: 2% 8%;
}
.prtitle .prize-card-area .pady7 {
  padding: 2% 7%;
}
.prtitle .prize-card-area img {
  border-radius: 20px;
  object-fit: fill;
  height: 100%;
}
.prtitle .prize-card-area .card-in .card-item {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.prtitle .prize-card-area .card-in .w20 {
  width: 20%;
}
.prtitle .prize-card-area .card-in .w25 {
  width: 25%;
}
.prtitle .prize-card-area .card-in .w33 {
  width: 33.3%;
}
.prtitle .prize-card-area .card-in .w50 {
  width: 50%;
}
.prtitle .prize-card-area .card-in .card-item .card-item-title {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1cqw;
  font-weight: 700;
}
.prtitle .prize-card-area .card-in .card-item .card-item-prize {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
}
.prtitle .prize-card-area .card-in .card-item .card-item-share {
  width: 100%;
  padding: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7cqw;
  font-weight: 700;
}
.ves-popup {
  position: fixed !important;
  z-index: 99999 !important;
}
.cesium-viewer-animationContainer,
.cesium-viewer-timelineContainer,
.cesium-viewer-bottom {
  display: none !important;
}
.w100 {
  width: 100% !important;
}
.ready-msg {
  text-align: start;
  color: var(--color-white);
  background-color: var(--color-second);
  border-radius: 15px;
  padding: 2% 3%;
  font-size: 0.8cqw;
  font-weight: 500;
  margin-bottom: 3%;
}
.error-msg {
  text-align: start;
  color: red;
  background-color: var(--color-first);
  border-radius: 15px;
  padding: 2% 3%;
  font-size: 0.8cqw;
  font-weight: 500;
  margin-bottom: 3%;
}
.success-msg {
  text-align: start;
  color: var(--color-white);
  background-color: var(--color-first);
  border-radius: 15px;
  padding: 2% 3%;
  font-size: 0.8cqw;
  font-weight: 500;
  margin-bottom: 3%;
}
.success-msg a,
.error-msg a {
  color: var(--color-third);
}
.btn-disabled {
  cursor: not-allowed;
  pointer-events: none;
}
button:focus:not(:focus-visible) {
  box-shadow: none;
}
.ticket {
  border: 1px solid #000;
  border-radius: 12px;
  margin: 4px;
  padding: 6px;
  font-size: 12pt;
}
.ticket p {
  border: 1px solid #000;
  border-radius: 12px;
  margin: 2px;
  padding: 0 6px;
}
.ticket p span {
  margin: 0;
  padding: 0 2px;
  font-size: 10pt;
  display: block;
}
.filter-area {
  position: absolute;
  right: -65%;
  top: 5%;
  z-index: 999;
}
.container-m {
  height: 65vh;
  overflow-y: auto;
}
.container-m::-webkit-scrollbar-track {
  background: var(--color-white);
}

.container-m::-webkit-scrollbar-thumb {
  background-color: var(--color-second);
  border-radius: 10px;
}
.ticket-area {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-family: "Ubuntu", sans-serif;
  overflow-y: auto;
}
.ticket-area::-webkit-scrollbar-track {
  background: none;
}

.ticket-area::-webkit-scrollbar-thumb {
  background-color: var(--color-second);
  border-radius: 50px;
}
.ticket-area .ticket-item {
  width: 20%;
  padding: 1%;
  position: relative;
  font-family: "Eurostile Extended", sans-serif;
}
.ticket-area .ticket-details {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30% 10%;
}
.ticket-area .ticket-details .detail-id {
  color: var(--color-white);
  font-size: 1cqw;
  padding: 2% 5%;
  border: 1px solid var(--color-white);
  border-radius: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 10cqw;
}
.ticket-area .ticket-details .detail-id span {
  font-size: 1.5cqw;
}
.ticket-area .ticket-details .detail-prize {
  color: var(--color-white);
  font-size: 0.6cqw;
  padding: 3% 0;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  text-shadow: 0 0 5px white;
}
.ticket-area .ticket-details .detail-prize span {
  font-size: 2.5cqw;
  letter-spacing: -3px;
}
.ticket-area .ticket-details .detail-s {
  color: var(--color-black);
  background-color: var(--color-white);
  font-size: 0.8cqw;
  padding: 3% 5%;
  border-radius: 10px;
  margin: 5% 0;
  line-height: 1;
  width: 10cqw;
}
.ticket-area .ticket-details .detail-info {
  color: var(--color-black);
  font-size: 0.9cqw;
  font-weight: 700;
  margin-top: 20%;
  letter-spacing: 2px;
}
.mobile-sidebar-toggle {
  display: none;
}
@keyframes mobileShowAnim {
  0% {
    top: 120%;
  }
  100% {
    top: 15%;
  }
}
@media (max-width: 760px) {
  /* .vestbody {
    display: none;
  }
  .pop {
    display: block !important;
  } */
  .cmap {
    width: 100% !important;
    height: 100cqh !important;
  }
  .globe {
    display: none;
  }
  .content-wrapper {
    position: relative;
    height: 100cqh;
  }
  .arr-right-link {
    width: 10cqw;
    height: 15cqw;
    position: absolute;
    right: 45%;
    top: -4%;
    transform: rotate(270deg);
  }
  .shows {
    position: absolute;
    top: 15%;
    left: 0;
    width: 100%;
    border-radius: 40px;
    animation: mobileShowAnim 2s;
  }
  .showsarrow {
    display: none;
  }
  .mobile-sidebar-toggle {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 111;
  }
  .mobile-sidebar-toggle span {
    color: white;
    font-size: 5cqw;
    position: absolute;
    text-align: center;
    top: 20%;
    left: 30%;
  }
  .mobile-sidebar-toggle img {
    position: absolute;
    top: 60%;
    left: 50%;
  }
  .search-item input {
    border-radius: 20px;
    font-size: 4cqw;
  }
  .container-m {
    height: 55vh;
    padding-left: 15%;
  }
  .title-list,
  .title-list-hide {
    font-size: 5cqw;
  }
  .title-list::before {
    width: 5cqw;
    height: 5cqw;
    background-size: 5cqw;
  }
  .title-list-hide::before {
    width: 4cqw;
    height: 3cqw;
    background-size: 4cqw;
  }
  .staking-list a {
    font-size: 5cqw;
  }
  .staking-list a:before {
    width: 4cqw;
    height: 4cqw;
    background-size: 3cqw;
    margin-right: 3%;
  }
  .container-box {
    width: 90cqw;
    right: 5cqw;
    border-radius: 20px;
  }
  .stakeheader .info .text {
    font-size: 3cqw;
  }
  .stakeheader img {
    height: 4.25cqw;
  }
  .stakeheader .info {
    font-size: 2.5cqw;
  }
  .pool-info .info-item {
    font-size: 3cqw;
  }
  .pool-info .info-item .detail a {
    font-size: 2.75cqw;
  }
  .minamount {
    font-size: 2.5cqw;
  }
  .error-msg,
  .success-msg,
  .ready-msg {
    font-size: 3cqw;
  }
  .unlock-msg {
    font-size: 2cqw;
  }
  .footer {
    font-size: 3.5cqw;
  }
  .stake-button {
    font-size: 4cqw;
  }
  .prtitle {
    font-size: 4cqw;
    border-radius: 20px;
    padding: 10% 0;
  }
  .prize-title {
    font-size: 4cqw;
    margin-bottom: 5%;
  }
  .ticket-area .ticket-item {
    width: 40%;
    margin: 0 !important;
  }
  .ticket-area .ticket-details .detail-id {
    font-size: 2.5cqw;
    width: 23cqw;
  }
  .ticket-area .ticket-details .detail-id span {
    font-size: 3.5cqw;
  }
  .ticket-area .ticket-details .detail-prize {
    font-size: 2cqw;
  }
  .ticket-area .ticket-details .detail-prize span {
    font-size: 7.5cqw;
  }
  .ticket-area .ticket-details .detail-s {
    font-size: 2cqw;
    width: 25cqw;
  }
  .ticket-area .ticket-details .detail-info {
    font-size: 2.5cqw;
    letter-spacing: 0;
  }
  .prtitle .prize-info {
    font-size: 2.5cqw;
  }
  .prtitle .prize-card-area,
  .prtitle .prize-card-area img {
    height: auto;
  }
  .prtitle .prize-bottom-info {
    font-size: 2.5cqw;
    margin-top: 5%;
  }
  .prtitle .prize-card-area .card-in .mobile-item2 {
    width: 50%;
    height: auto;
  }
  .prtitle .prize-card-area .card-in .mobile-item3 {
    width: 33.33%;
    height: auto;
  }
  .prtitle .prize-card-area .pady14 {
    padding: 5% 10%;
  }
  .prtitle .prize-card-area .pady7 {
    padding: 3% 8%;
  }
  .prtitle .prize-card-area .pady8 {
    padding: 5% 10%;
  }
  .prtitle .prize-card-area .pady10 {
    padding: 3% 9%;
  }
  .prtitle .prize-card-area .card-in .mobile-item4 {
    height: 50%;
    width: 50%;
  }
  .prtitle .prize-card-area .card-in .mobile-item5 {
    height: 50%;
    width: 33.33%;
  }
  .prtitle .prize-card-area .card-in .card-item .card-item-title {
    font-size: 2.25cqw;
  }
  .prtitle .prize-card-area .card-in .card-item .card-item-share {
    font-size: 1.75cqw;
    padding: 3%;
  }
  .search-list a {
    font-size: 4cqw;
  }
  .pool-info .info-item .progress-container .text {
    font-size: 3cqw;
  }
  .token-amount .input-area input {
    font-size: 4cqw;
    padding-right: 10%;
  }
  .token-amount .input-area input::placeholder {
    font-size: 3cqw;
  }
}
.cesium-viewer-toolbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAKE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB;oBACkB;EAClB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,6DAAsD;EACtD,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,6DAAsD;EACtD,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6DAA+C;EAC/C,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,6DAAqD;EACrD,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,6DAAuD;EACvD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,SAAS;EACT,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,OAAO;EACP,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;AACA;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC;;;;;;;gBAOc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;KAKG;EACH;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.cdnfonts.com/css/eurostile-extended\");\n\n:root {\n  --color-first: #583760;\n  --color-second: #b7d48c;\n  --color-third: #ed7a58;\n  --color-white: #f6efe3;\n  --color-black: #161711;\n  --color-first-opacity: #a793a1;\n  --font-family-first: \"Montserrat\", sans-serif;\n  --font-family-second: \"Ubuntu\", sans-serif;\n}\n\n.font-first {\n  font-family: var(--font-family-first);\n}\n.font-second {\n  font-family: var(--font-family-second);\n}\nhtml {\n  width: 100%;\n}\n\nbody {\n  width: 100%;\n  margin: 0;\n  padding-top: 0;\n  background: var(--color-white) !important;\n  overflow: hidden;\n}\n\na,\na img {\n  text-decoration: none;\n  outline: none;\n  border: none;\n}\n\na:hover {\n  text-decoration: none !important;\n}\n\n.clr {\n  clear: both;\n  height: 0;\n}\n\n.fancybox-button svg path {\n  color: #fff !important;\n}\n\n*,\n*:after,\n*::before {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  list-style-type: none;\n  outline: none;\n}\n\na:focus {\n  outline: 0;\n}\n\na {\n  text-decoration: none !important;\n}\n\n.left-menu-area {\n  width: 25%;\n  display: flex;\n  flex-direction: column;\n  padding: 40px;\n  position: relative;\n  background: var(--color-white);\n  padding-bottom: 400px;\n  height: 100vh;\n  font-family: var(--font-family-first);\n}\n\n.content-wrapper {\n  display: flex;\n}\n.search-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 20px;\n}\n.search-item input {\n  border-radius: 5px;\n  background: var(--color-first-opacity) url(./assets/img/search-icon.png)\n    no-repeat 6% 50%;\n  background-size: 20px;\n  border: 0;\n  padding: 5% 15%;\n  color: var(--color-white);\n  width: 100%;\n  font-size: 1cqw;\n}\n.search-item input::placeholder {\n  color: var(--color-white);\n}\n.search-item img {\n  width: 3cqw;\n  margin-left: 5%;\n  cursor: pointer;\n}\n.title-list {\n  display: flex;\n  align-items: center;\n  color: var(--color-first);\n  font-weight: 600;\n  position: relative;\n  font-size: 1.25cqw;\n  margin-bottom: 1%;\n  cursor: pointer;\n}\n.title-list::before {\n  display: inline-flex;\n  width: 2cqw;\n  height: 1.5cqw;\n  background: url(./assets/img/arrow-down.png) no-repeat;\n  content: \"\";\n  background-size: 1cqw;\n  background-position: center;\n  cursor: pointer;\n}\n\n.title-list-hide {\n  display: flex;\n  align-items: center;\n  color: var(--color-first);\n  font-weight: 600;\n  position: relative;\n  font-size: 1.25cqw;\n  margin-bottom: 1%;\n  cursor: pointer;\n}\n.title-list-hide::before {\n  display: inline-flex;\n  width: 1cqw;\n  height: 1cqw;\n  background: url(./assets/img/arrow-down.png) no-repeat;\n  content: \"\";\n  background-size: 1cqw;\n  transform: rotate(-90deg);\n  cursor: pointer;\n}\n\n.staking-list {\n  display: flex;\n  flex-direction: column;\n  padding-left: 25px;\n  margin-bottom: 20px;\n}\n.staking-list a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: var(--color-black);\n  font-size: 1cqw;\n  font-weight: 400;\n}\n.staking-list a:before {\n  display: inline-flex;\n  width: 2cqw;\n  height: 2cqw;\n  content: \"\";\n  background: url(./assets/img/pin.png) no-repeat;\n  background-position: center;\n  background-size: 1cqw;\n}\n.staking-list a:hover::before {\n  background: url(./assets/img/pin-hover.png) no-repeat;\n  background-position: center;\n  background-size: 1cqw;\n}\n.staking-list a:hover {\n  color: #ee4c34;\n}\n.arr-right-link {\n  background: url(./assets/img/arrow-right.png) no-repeat;\n  width: 3cqw;\n  height: 5cqw;\n  background-size: 100%;\n  position: absolute;\n  right: -10%;\n  top: 40%;\n  transform: translate(-50%, 0);\n  z-index: 2;\n  cursor: pointer;\n}\n\n.right-map-area {\n  width: 100%;\n  position: absolute;\n}\n#map {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: calc(100vh - 100px);\n}\n.hider {\n  background: var(--color-white);\n  width: 100%;\n  height: 108px;\n  position: absolute;\n  margin-top: -108px;\n}\n.tophider {\n  background: var(--color-white);\n  width: 100%;\n  height: 108px;\n  position: absolute;\n  margin-top: -108px;\n}\n.pointer {\n  cursor: pointer;\n}\n.pop {\n  display: none;\n  position: fixed;\n  z-index: 99999;\n  top: 0;\n}\n.pop img {\n  width: 100%;\n}\n.title-list {\n  cursor: pointer;\n}\n.shows {\n  display: block;\n}\n.hides {\n  display: none;\n}\n.wide {\n  width: 100%;\n}\n.narrow {\n  width: 80%;\n}\n.showsarrow {\n  display: block;\n  left: -1%;\n  top: 50%;\n  transform: rotate(180deg);\n}\n.hidesarrow {\n  display: none;\n}\n.span2 {\n  text-indent: 7px;\n}\n#loadingOverlay {\n  /* margin-top: -24px; */\n}\n.globe {\n  cursor: pointer;\n  position: absolute;\n  width: 41px;\n  z-index: 99;\n  left: 26%;\n  background: var(--color-white);\n  border-radius: 14px;\n  padding: 5px;\n  margin-top: 12px;\n}\n.search-list {\n  position: absolute;\n  z-index: 999;\n  width: 100%;\n  top: 12%;\n  left: 0;\n  padding: 0 10%;\n}\n.search-list .in {\n  background-color: #fac3aeee;\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n}\n.search-list a {\n  color: var(--color-first);\n  padding: 3%;\n  cursor: pointer;\n  font-size: 1cqw;\n}\n.search-list a:not(:last-child) {\n  border-bottom: 1px solid var(--color-black);\n}\n.visible {\n}\n.hidden {\n  display: none;\n}\n.cmap {\n  position: absolute;\n}\n.w80 {\n  width: 80%;\n  height: 100%;\n}\n.loader {\n  position: fixed;\n  width: 100%;\n  background: #f6efe3bd;\n  z-index: 9999;\n  height: 100%;\n  top: 0;\n  text-align: center;\n}\n.prtitle {\n  width: 80cqw;\n  height: 80cqh;\n  border: 5px solid transparent;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-size: 1.5cqw;\n  padding: 2% 5%;\n  font-weight: 600;\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: linear-gradient(var(--color-white) 0 0) padding-box,\n    linear-gradient(\n        to top,\n        var(--color-first) 0%,\n        var(--color-third) 50%,\n        var(--color-second) 100%\n      )\n      border-box;\n  overflow-y: auto;\n  font-family: var(--font-family-first);\n}\n\n.prtitle::-webkit-scrollbar-track {\n  background: none;\n}\n\n.prtitle::-webkit-scrollbar-thumb {\n  background-color: var(--color-second);\n  border-radius: 50px;\n}\n.prize-title {\n  font-size: 1.5cqw;\n  font-weight: 600;\n}\n.prtitle .prize-info {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30%;\n  font-size: 1cqw;\n  font-weight: 700;\n}\n.prtitle .prize-bottom-info {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10%;\n  font-size: 1cqw;\n  font-weight: 700;\n}\n.prtitle .prize-card-area {\n  width: fit-content;\n  padding: 0 5%;\n  position: relative;\n  height: 38cqh;\n}\n.prtitle .prize-card-area .card-in {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n}\n.prtitle .prize-card-area .pady14 {\n  padding: 2% 14%;\n}\n.prtitle .prize-card-area .pady10 {\n  padding: 2% 10%;\n}\n.prtitle .prize-card-area .pady8 {\n  padding: 2% 8%;\n}\n.prtitle .prize-card-area .pady7 {\n  padding: 2% 7%;\n}\n.prtitle .prize-card-area img {\n  border-radius: 20px;\n  object-fit: fill;\n  height: 100%;\n}\n.prtitle .prize-card-area .card-in .card-item {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n}\n.prtitle .prize-card-area .card-in .w20 {\n  width: 20%;\n}\n.prtitle .prize-card-area .card-in .w25 {\n  width: 25%;\n}\n.prtitle .prize-card-area .card-in .w33 {\n  width: 33.3%;\n}\n.prtitle .prize-card-area .card-in .w50 {\n  width: 50%;\n}\n.prtitle .prize-card-area .card-in .card-item .card-item-title {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.1cqw;\n  font-weight: 700;\n}\n.prtitle .prize-card-area .card-in .card-item .card-item-prize {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--color-white);\n}\n.prtitle .prize-card-area .card-in .card-item .card-item-share {\n  width: 100%;\n  padding: 6%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.7cqw;\n  font-weight: 700;\n}\n.ves-popup {\n  position: fixed !important;\n  z-index: 99999 !important;\n}\n.cesium-viewer-animationContainer,\n.cesium-viewer-timelineContainer,\n.cesium-viewer-bottom {\n  display: none !important;\n}\n.w100 {\n  width: 100% !important;\n}\n.ready-msg {\n  text-align: start;\n  color: var(--color-white);\n  background-color: var(--color-second);\n  border-radius: 15px;\n  padding: 2% 3%;\n  font-size: 0.8cqw;\n  font-weight: 500;\n  margin-bottom: 3%;\n}\n.error-msg {\n  text-align: start;\n  color: red;\n  background-color: var(--color-first);\n  border-radius: 15px;\n  padding: 2% 3%;\n  font-size: 0.8cqw;\n  font-weight: 500;\n  margin-bottom: 3%;\n}\n.success-msg {\n  text-align: start;\n  color: var(--color-white);\n  background-color: var(--color-first);\n  border-radius: 15px;\n  padding: 2% 3%;\n  font-size: 0.8cqw;\n  font-weight: 500;\n  margin-bottom: 3%;\n}\n.success-msg a,\n.error-msg a {\n  color: var(--color-third);\n}\n.btn-disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n}\nbutton:focus:not(:focus-visible) {\n  box-shadow: none;\n}\n.ticket {\n  border: 1px solid #000;\n  border-radius: 12px;\n  margin: 4px;\n  padding: 6px;\n  font-size: 12pt;\n}\n.ticket p {\n  border: 1px solid #000;\n  border-radius: 12px;\n  margin: 2px;\n  padding: 0 6px;\n}\n.ticket p span {\n  margin: 0;\n  padding: 0 2px;\n  font-size: 10pt;\n  display: block;\n}\n.filter-area {\n  position: absolute;\n  right: -65%;\n  top: 5%;\n  z-index: 999;\n}\n.container-m {\n  height: 65vh;\n  overflow-y: auto;\n}\n.container-m::-webkit-scrollbar-track {\n  background: var(--color-white);\n}\n\n.container-m::-webkit-scrollbar-thumb {\n  background-color: var(--color-second);\n  border-radius: 10px;\n}\n.ticket-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  font-family: \"Ubuntu\", sans-serif;\n  overflow-y: auto;\n}\n.ticket-area::-webkit-scrollbar-track {\n  background: none;\n}\n\n.ticket-area::-webkit-scrollbar-thumb {\n  background-color: var(--color-second);\n  border-radius: 50px;\n}\n.ticket-area .ticket-item {\n  width: 20%;\n  padding: 1%;\n  position: relative;\n  font-family: \"Eurostile Extended\", sans-serif;\n}\n.ticket-area .ticket-details {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30% 10%;\n}\n.ticket-area .ticket-details .detail-id {\n  color: var(--color-white);\n  font-size: 1cqw;\n  padding: 2% 5%;\n  border: 1px solid var(--color-white);\n  border-radius: 10px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 10cqw;\n}\n.ticket-area .ticket-details .detail-id span {\n  font-size: 1.5cqw;\n}\n.ticket-area .ticket-details .detail-prize {\n  color: var(--color-white);\n  font-size: 0.6cqw;\n  padding: 3% 0;\n  line-height: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: auto;\n  text-shadow: 0 0 5px white;\n}\n.ticket-area .ticket-details .detail-prize span {\n  font-size: 2.5cqw;\n  letter-spacing: -3px;\n}\n.ticket-area .ticket-details .detail-s {\n  color: var(--color-black);\n  background-color: var(--color-white);\n  font-size: 0.8cqw;\n  padding: 3% 5%;\n  border-radius: 10px;\n  margin: 5% 0;\n  line-height: 1;\n  width: 10cqw;\n}\n.ticket-area .ticket-details .detail-info {\n  color: var(--color-black);\n  font-size: 0.9cqw;\n  font-weight: 700;\n  margin-top: 20%;\n  letter-spacing: 2px;\n}\n.mobile-sidebar-toggle {\n  display: none;\n}\n@keyframes mobileShowAnim {\n  0% {\n    top: 120%;\n  }\n  100% {\n    top: 15%;\n  }\n}\n@media (max-width: 760px) {\n  /* .vestbody {\n    display: none;\n  }\n  .pop {\n    display: block !important;\n  } */\n  .cmap {\n    width: 100% !important;\n    height: 100cqh !important;\n  }\n  .globe {\n    display: none;\n  }\n  .content-wrapper {\n    position: relative;\n    height: 100cqh;\n  }\n  .arr-right-link {\n    width: 10cqw;\n    height: 15cqw;\n    position: absolute;\n    right: 45%;\n    top: -4%;\n    transform: rotate(270deg);\n  }\n  .shows {\n    position: absolute;\n    top: 15%;\n    left: 0;\n    width: 100%;\n    border-radius: 40px;\n    animation: mobileShowAnim 2s;\n  }\n  .showsarrow {\n    display: none;\n  }\n  .mobile-sidebar-toggle {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 111;\n  }\n  .mobile-sidebar-toggle span {\n    color: white;\n    font-size: 5cqw;\n    position: absolute;\n    text-align: center;\n    top: 20%;\n    left: 30%;\n  }\n  .mobile-sidebar-toggle img {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n  }\n  .search-item input {\n    border-radius: 20px;\n    font-size: 4cqw;\n  }\n  .container-m {\n    height: 55vh;\n    padding-left: 15%;\n  }\n  .title-list,\n  .title-list-hide {\n    font-size: 5cqw;\n  }\n  .title-list::before {\n    width: 5cqw;\n    height: 5cqw;\n    background-size: 5cqw;\n  }\n  .title-list-hide::before {\n    width: 4cqw;\n    height: 3cqw;\n    background-size: 4cqw;\n  }\n  .staking-list a {\n    font-size: 5cqw;\n  }\n  .staking-list a:before {\n    width: 4cqw;\n    height: 4cqw;\n    background-size: 3cqw;\n    margin-right: 3%;\n  }\n  .container-box {\n    width: 90cqw;\n    right: 5cqw;\n    border-radius: 20px;\n  }\n  .stakeheader .info .text {\n    font-size: 3cqw;\n  }\n  .stakeheader img {\n    height: 4.25cqw;\n  }\n  .stakeheader .info {\n    font-size: 2.5cqw;\n  }\n  .pool-info .info-item {\n    font-size: 3cqw;\n  }\n  .pool-info .info-item .detail a {\n    font-size: 2.75cqw;\n  }\n  .minamount {\n    font-size: 2.5cqw;\n  }\n  .error-msg,\n  .success-msg,\n  .ready-msg {\n    font-size: 3cqw;\n  }\n  .unlock-msg {\n    font-size: 2cqw;\n  }\n  .footer {\n    font-size: 3.5cqw;\n  }\n  .stake-button {\n    font-size: 4cqw;\n  }\n  .prtitle {\n    font-size: 4cqw;\n    border-radius: 20px;\n    padding: 10% 0;\n  }\n  .prize-title {\n    font-size: 4cqw;\n    margin-bottom: 5%;\n  }\n  .ticket-area .ticket-item {\n    width: 40%;\n    margin: 0 !important;\n  }\n  .ticket-area .ticket-details .detail-id {\n    font-size: 2.5cqw;\n    width: 23cqw;\n  }\n  .ticket-area .ticket-details .detail-id span {\n    font-size: 3.5cqw;\n  }\n  .ticket-area .ticket-details .detail-prize {\n    font-size: 2cqw;\n  }\n  .ticket-area .ticket-details .detail-prize span {\n    font-size: 7.5cqw;\n  }\n  .ticket-area .ticket-details .detail-s {\n    font-size: 2cqw;\n    width: 25cqw;\n  }\n  .ticket-area .ticket-details .detail-info {\n    font-size: 2.5cqw;\n    letter-spacing: 0;\n  }\n  .prtitle .prize-info {\n    font-size: 2.5cqw;\n  }\n  .prtitle .prize-card-area,\n  .prtitle .prize-card-area img {\n    height: auto;\n  }\n  .prtitle .prize-bottom-info {\n    font-size: 2.5cqw;\n    margin-top: 5%;\n  }\n  .prtitle .prize-card-area .card-in .mobile-item2 {\n    width: 50%;\n    height: auto;\n  }\n  .prtitle .prize-card-area .card-in .mobile-item3 {\n    width: 33.33%;\n    height: auto;\n  }\n  .prtitle .prize-card-area .pady14 {\n    padding: 5% 10%;\n  }\n  .prtitle .prize-card-area .pady7 {\n    padding: 3% 8%;\n  }\n  .prtitle .prize-card-area .pady8 {\n    padding: 5% 10%;\n  }\n  .prtitle .prize-card-area .pady10 {\n    padding: 3% 9%;\n  }\n  .prtitle .prize-card-area .card-in .mobile-item4 {\n    height: 50%;\n    width: 50%;\n  }\n  .prtitle .prize-card-area .card-in .mobile-item5 {\n    height: 50%;\n    width: 33.33%;\n  }\n  .prtitle .prize-card-area .card-in .card-item .card-item-title {\n    font-size: 2.25cqw;\n  }\n  .prtitle .prize-card-area .card-in .card-item .card-item-share {\n    font-size: 1.75cqw;\n    padding: 3%;\n  }\n  .search-list a {\n    font-size: 4cqw;\n  }\n  .pool-info .info-item .progress-container .text {\n    font-size: 3cqw;\n  }\n  .token-amount .input-area input {\n    font-size: 4cqw;\n    padding-right: 10%;\n  }\n  .token-amount .input-area input::placeholder {\n    font-size: 3cqw;\n  }\n}\n.cesium-viewer-toolbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
